import { CSSProperties, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { SelectOptionsDropdown } from "@ryde/controls";
import {
  bookingCalendarDataSelector,
  datesArrayCalendarBookingsSF,
  selectedCellsBookingCalendarAtom,
  SelectionEnum,
  setCheckedHandler,
  timezoneAdjustedDateToDayStartISO,
  timezoneAdjustedDateToISO,
  useFormats,
  useTimezone,
  wholeColumnSelectedBookingCalendarSF,
} from "@ryde/shared";

interface IBookingCalendarRowDatesCell {
  style: CSSProperties;
  rowIndex: number;
  columnIndex: number;
}

export const BookingCalendarRowDatesCell = ({
  style,
  columnIndex,
}: IBookingCalendarRowDatesCell): ReactElement => {
  const { i18n } = useTranslation();
  const { formatDayOfWeekTranslated, formatDateNormalized } = useFormats();
  const { timezone } = useTimezone();
  const dates = useRecoilValue(datesArrayCalendarBookingsSF);
  const date = dates[columnIndex];
  const { cols } = useRecoilValue(bookingCalendarDataSelector);
  const setSelectedCell = useSetRecoilState(selectedCellsBookingCalendarAtom);
  const colSelectedState = useRecoilValue(
    wholeColumnSelectedBookingCalendarSF(date),
  );

  const setChecked = (value: SelectionEnum): void => {
    setCheckedHandler[value]({
      setter: setSelectedCell,
      rowOrCol: cols.get(date) ?? new Set(),
    });
  };

  const shortDayOfWeekTranslated = formatDayOfWeekTranslated(
    i18n.language,
    { weekday: "short" },
    "upper",
    timezoneAdjustedDateToDayStartISO(date, timezone),
  );

  const dateIso = timezoneAdjustedDateToISO(date, timezone);
  return (
    <div className="head_cell" style={style}>
      <span className="checkbox">
        <SelectOptionsDropdown
          checked={colSelectedState}
          setChecked={setChecked}
        />
      </span>
      <span className="checkbox_label">{shortDayOfWeekTranslated}</span>
      <span className="full_date">{formatDateNormalized(dateIso)}</span>
    </div>
  );
};
